export enum WorkOrderStatusEnum {
  Draft = 'Draft',
  InProgress = 'In Progress',
  Complete = 'Complete',
  Cancelled = 'Cancelled',
  Destructed = 'Destructed',
}
